/**
 * Application Block Configuration
 * Centralized configuration for the Application block
 */
export const APPLICATION_CONFIG = {
  /**
   * Number of occasions to display per page
   * Can be overridden by block configuration if needed
   */
  DEFAULT_PAGE_SIZE: 5,

  /**
   * Maximum number of occasions to load at once
   * Prevents performance issues with large datasets
   */
  MAX_OCCASIONS: 100,

  /**
   * Sorting and filtering defaults
   */
  DEFAULTS: {
    SORT_BY_FOLDER_POSITION: false,
    OCCASION_TYPE: 'Occasion',
  },

  /**
   * Performance settings
   */
  PERFORMANCE: {
    DEBOUNCE_DELAY: 300,
  },
} as const;
